<template>
	<div>
		<v-navigation-drawer :fixed="true" class="hidden-md-and-up" v-model="sideNav">
			<v-list-item>
				<v-list-item-content>
					<span style="height: 5px; color: white;">.<br/></span>
					<router-link to="/" tag="span" style="cursor: pointer">
						<v-list-item-title class="font-weight-bold blueText text-uppercase point6" style="margin-left: 16px;">
							ME/CFS Group &bull; Canterbury
						</v-list-item-title>
					</router-link>
				</v-list-item-content>
			</v-list-item>

			<v-divider></v-divider>

			<v-list nav>
				<v-list v-for="item in items" :key="item.title">
					<v-list-tile>
						<v-list-tile-content>
							<router-link :to="item.link" style="textDecoration: none;">
								<v-list-tile-title class="font-weight-bold blueText point6" >{{item.title}}</v-list-tile-title>
							</router-link>
						</v-list-tile-content>
					</v-list-tile>
					<v-list-item v-for="subItem in item.subgroups" :key="subItem.title">
						<router-link :to="subItem.link" style="textDecoration: none;">
							<v-list-tile>
								<v-list-tile-title style="margin-left: 25px; color: black; font-size: 18px!important;">{{subItem.title}}</v-list-tile-title>
							</v-list-tile>
						</router-link>
					</v-list-item>
				</v-list>
			</v-list>
		</v-navigation-drawer>

		<v-toolbar :fixed="true" class="primary" style="min-height: 64px; background: linear-gradient(90deg,#261C84,#2856B0)">
			<v-toolbar-side-icon @click.stop="sideNav = !sideNav" class="hidden-md-and-up white"></v-toolbar-side-icon>

			<v-spacer></v-spacer>

			<router-link to="/" tag="span">
				<div>
					<v-btn flat target="_blank">
						<v-toolbar-title class="text-uppercase point55">
							<span class="font-weight-bold whiteText">ME/CFS Group &bull; </span>
							<span class="font-weight-bold whiteText">Canterbury</span>
						</v-toolbar-title>
					</v-btn>
				</div>
			</router-link>

			<v-spacer></v-spacer>

			<template>
				<div class="hidden-sm-and-down" v-for="item in items" :key="item.title">
					<v-menu bottom open-on-hover offset-y>
						<template v-slot:activator="{ on }">
							<router-link :to="item.link" tag="span">
								<div style="height: 4vh">
									<v-tab v-on="on" flat target="_blank" class="font-weight-bold whiteText point35">{{item.title}}</v-tab>
								</div>
							</router-link>
						</template>
						<v-list v-if="item.subgroups">
							<v-hover v-for="subItem in item.subgroups" :key="subItem.title">
								<router-link :to="subItem.link" slot-scope="{ hover }" style="textDecoration: none;" :append="false">
									<v-list-tile :class="hover ? 'secondary' : ''">
										<v-list-tile-title :class="hover ? 'whiteText' : ''">{{ subItem.title }}</v-list-tile-title>
									</v-list-tile>
								</router-link>
							</v-hover>
						</v-list>
					</v-menu>
				</div>
			</template>

			<v-spacer></v-spacer>

		</v-toolbar>
	</div>
</template>

<script>

export default {
	name: "MainMenu",
	props: ['items'],
	data() {
		return {
			sideNav: false,
			windowWidth: window.innerWidth 
		}
	},
	computed: {
		spaceForWideTitle() {
			return this.windowWidth > 420;
		}
	},
  created() {
    window.addEventListener('resize', this.handleResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    }
  }
}

</script>